import { FC, HTMLAttributes } from "react";

export interface ITextAttributes extends HTMLAttributes<HTMLSpanElement> {
    text?: string,
}

export const Span: FC<ITextAttributes> = ({
    text, children, ...props
}) => {
    return <span {...props}>
        {text}
        {children}
    </span>
}